import { render, staticRenderFns } from "./AdminRoleList.vue?vue&type=template&id=19915064&"
import script from "./AdminRoleList.vue?vue&type=script&lang=ts&"
export * from "./AdminRoleList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports